import React from "react";
import { Search, Sprout, AlertTriangle, Brush, Droplets, Camera, ClipboardList, ArrowRight, Info } from "lucide-react";
import { Button } from "./ui/button";

const checks = [
  { icon: Search, t: "Visuell kontroll av taket", d: "Vi går igenom takets allmänna skick och synliga ytor." },
  { icon: Sprout, t: "Synlig mossa & alger", d: "Vi bedömer påväxt som påverkar takets funktion och utseende." },
  { icon: AlertTriangle, t: "Synliga skador på pannor", d: "Vi noterar spruckna, glidna eller skadade takpannor." },
  { icon: Brush, t: "Målning & ytskikt", d: "Vi kollar färgens och ytskiktets synliga status." },
  { icon: Droplets, t: "Hängrännor & detaljer", d: "Vi ser över synliga hängrännor, nock och plåtdetaljer." },
  { icon: Camera, t: "Foto & dokumentation", d: "Vi fotar taket så du får det svart på vitt." },
  { icon: ClipboardList, t: "Rekommendation om nästa steg", d: "Du får en tydlig rekommendation – utan förpliktelser." },
];

export default function TakKoll() {
  return (
    <section id="takkoll" className="hpr-blue-tint py-16 lg:py-24 scroll-mt-20">
      <div className="mx-auto max-w-7xl px-6">
        <div className="reveal max-w-3xl">
          <p className="text-sm font-bold uppercase tracking-[0.15em] text-[#1B45C4]">HPR TakKoll</p>
          <h2 className="mt-3 text-3xl sm:text-4xl font-extrabold text-slate-900">
            HPR TakKoll – få koll på takets skick innan problemen blir dyra
          </h2>
          <p className="mt-4 text-slate-600 text-lg">
            En kostnadsfri, visuell genomgång av ditt tak. Du får foton, en tydlig bild av skicket
            och en rekommendation om nästa steg – helt utan förbindelse.
          </p>
        </div>

        <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {checks.map((c) => (
            <div key={c.t} className="reveal rounded-2xl bg-white p-6 ring-1 ring-[#dbeafe] transition-all hover:shadow-xl hover:shadow-[#1B45C4]/10 hover:-translate-y-1">
              <div className="flex h-11 w-11 items-center justify-center rounded-xl bg-[#38BDF8]/15">
                <c.icon className="w-5 h-5 text-[#1B45C4]" />
              </div>
              <h3 className="mt-4 font-bold text-slate-900">{c.t}</h3>
              <p className="mt-1.5 text-sm text-slate-600">{c.d}</p>
            </div>
          ))}
        </div>

        <div className="reveal mt-8 flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between rounded-2xl bg-white p-6 ring-1 ring-[#dbeafe]">
          <p className="flex items-start gap-2 text-sm text-slate-500 max-w-xl">
            <Info className="w-4 h-4 shrink-0 mt-0.5 text-[#1B45C4]" />
            TakKoll är en visuell bedömning av takets synliga skick – inte en konstruktions- eller byggnadsteknisk besiktning.
          </p>
          <Button asChild className="shrink-0 rounded-full h-13 px-8 py-3 bg-[#1B45C4] hover:bg-[#12308f] text-white font-semibold">
            <a href="#kontakt" data-testid="takkoll-cta">Boka kostnadsfri TakKoll <ArrowRight className="ml-2 w-5 h-5" /></a>
          </Button>
        </div>
      </div>
    </section>
  );
}
